import React, { memo } from "react";
import DashboardMetric from "./DashboardMetric";

const DashboardHero = memo(({ metrics = [], loading }) => {
  if (!loading && metrics.length === 0) return null;

  return (
    <section className="dash-hero" aria-label="Key metrics">
      {loading
        ? Array.from({ length: 4 }).map((_, i) => (
            <DashboardMetric key={`skel-${i}`} title="—" value={0} loading variant="hero" />
          ))
        : metrics.map(({ key, ...metricProps }) => (
            <DashboardMetric key={key} {...metricProps} variant="hero" />
          ))}
    </section>
  );
});

DashboardHero.displayName = "DashboardHero";

export default DashboardHero;
